import React from "react";
import { Link } from "react-router-dom";
import { Twitter, Facebook, Instagram, Youtube } from "lucide-react";
import { Socials } from "../home";

const Disclaimer = () => {
  return (
    <div className="min-h-screen relative overflow-hidden">
      <div className="container mx-auto px-4 py-16 relative z-10">
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-8 text-center animate-fade-in">
          Disclaimer
        </h1>

        <div
          className="max-w-4xl mx-auto text-white/80 space-y-6 text-lg animate-fade-in"
          style={{ animationDelay: "0.3s" }}
        >
          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            General Risk Disclosure
          </h2>
          <p>
            Investing in the securities market involves market risks, including
            the potential for partial or complete loss of capital. Market
            conditions can be volatile and unpredictable, and the use of any
            strategy or tool does not guarantee success or profits. Past
            performance is not a guarantee or indicator of future results.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            No Investment Advice
          </h2>
          <p>
            None of the content, tools, illustrations, or strategies presented
            on marketpulse.exchange should be construed as investment advice,
            recommendations, or solicitations to buy or sell securities. All
            decisions made by users are entirely their own responsibility.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            Educational Content Only
          </h2>
          <p>
            All information shared across this platform, including on our
            dashboards, tools, blogs, or social media channels, is meant to
            serve as educational guidance. Our platform is designed to help
            traders understand market behavior, improve analysis, and execute
            based on personal conviction and risk appetite - not on suggestions
            made by us.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            No Guarantees or Returns
          </h2>
          <p>
            We do not and cannot guarantee any specific returns on the use of
            any feature, tool, or trade logic hosted on the platform. All
            trading involves risk.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            Liability Limitation
          </h2>
          <p>
            Project Options(TM) and marketpulse.exchange shall not be held
            liable for any direct, indirect, or consequential loss or damage
            that may arise from reliance on or use of any content, tool, or
            service provided on the platform.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            Third-Party Content and Tools
          </h2>
          <p>
            The platform may reference third-party content or link to external
            services/tools. These are provided for convenience only. We do not
            endorse or validate the content, accuracy, or reliability of
            external sources, and hold no responsibility for the same.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            Platform Usage
          </h2>
          <p>By accessing and using marketpulse.exchange, users agree that:</p>
          <ul className="list-disc list-inside space-y-3">
            <li>They have understood the risk involved in trading.</li>
            <li>They are responsible for their actions and decisions.</li>
            <li>
              They waive any right to hold Project Options(TM) or its team
              liable for market-related outcomes.
            </li>
          </ul>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            Disclaimer Updates
          </h2>
          <p>
            We reserve the right to update this disclaimer at any time without
            prior notice. Continued usage of the platform implies that you
            accept the latest terms and conditions.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            Contact Us
          </h2>
          <p>
            For clarification, concerns, or support, please contact us at:
            Email:{" "}
            <a
              className="text-market-teal/40 hover:text-market-teal"
              href="mailto://hello@projectoptions.in"
            >
              hello@projectoptions.in
            </a>
          </p>

          <div className="intellectia-card p-8 mt-12 text-center">
            <h3 className="text-xl font-semibold mb-4">Questions?</h3>
            <p className="mb-6">
              If you have any questions about our disclaimer or services, please
              contact our support team.
            </p>
            < Socials />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
